module.exports = __webpack_public_path__ + "static/tshirts/divider-5ec6562f5e5a7890a11a5defeb71395f.png";